import React from 'react';
import Grid from '@mui/material/Grid';
import { Paper, Typography, Box, Chip, Divider } from '@mui/material';

const MetricItem: React.FC<{ title: string; value: string | number | null }> = ({ title, value }) => (
    <Box sx={{ display: 'flex', justifyContent: 'space-between', py: 1 }}>
        <Typography variant="body2" color="text.secondary">{title}</Typography>
        <Typography variant="body2" sx={{ fontWeight: 'bold' }}>{value ?? 'N/A'}</Typography>
    </Box>
);

const CompanyAdvancedMetrics: React.FC<{ company: any }> = ({ company }) => {
    const signals = company.DetectedSignals ? company.DetectedSignals.split(';').map((s: string) => s.trim()) : [];

    return (
        <Paper sx={{ p: 2, height: '100%' }}>
            <Typography variant="h6" gutterBottom>Advanced Metrics</Typography>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <MetricItem title="Reporting Quality" value={company.ReportingQualityScore != null ? `${company.ReportingQualityScore.toFixed(0)}/100` : 'N/A'} />
                    <MetricItem title="Excellence Bonus" value={company.ExcellenceBonusPoints != null ? company.ExcellenceBonusPoints.toFixed(0) : 'N/A'} />
                </Grid>
            </Grid>
            <Divider sx={{ my: 2 }} />
            <Typography variant="h6" gutterBottom>Detected Signals</Typography>
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                {signals.length > 0 ? signals.map((signal: string, index: number) => (
                    <Chip key={index} label={signal} color="primary" variant="outlined" />
                )) : (
                    <Typography variant="body2" color="text.secondary">No specific signals detected.</Typography>
                )}
            </Box>
        </Paper>
    );
};

export default CompanyAdvancedMetrics;
